import React, { useEffect } from "react";
import { capitaliseFirstLetter } from "@breedr/utils";
// Libraries
import { Redirect, useParams } from "react-router-dom";
import { History } from "history";
// Utils
import { FIELDS } from "constants/Routes";
import { ELEMENTS_IDS } from "constants/ElementsIds";
// Hooks
import { useEventRequest } from "hooks";
// Components
import { FieldInfoBlock } from "components/MyLivestock";
import { LoadingOverlay, Breadcrumbs, Button, Header, PageContent, PageHeader, Spacer } from "components";
// Resources
import styles from "./Field.module.scss";
import { useFieldQuery } from "generated/graphql";
import { AnimalsList } from "animals/AnimalsList";

interface FieldViewProps {
  history: History;
}

export const Field: React.FC<FieldViewProps> = ({ history }) => {
  const { fieldId } = useParams<LivestockFieldPageParams>();
  const { eventsRequest } = useEventRequest();

  useEffect(() => {
    eventsRequest({ name: "field-view", details: { fieldId } });
  }, []);

  const { data, loading, error } = useFieldQuery({ variables: { id: fieldId } });

  const { field } = { ...data };

  if (error) {
    return <Redirect to={FIELDS} />;
  }

  return (
    <>
      {loading ? (
        <LoadingOverlay customStyles={styles.loadingOverlay} />
      ) : (
        <>
          <PageHeader>
            <Breadcrumbs
              rootPaths={[
                {
                  path: "Locations",
                  route: FIELDS,
                },
              ]}
              currentPath={`${capitaliseFirstLetter("location")} Information`}
            />

            <Header backButton title={field?.name || ""} subTitle="" />

            <FieldInfoBlock field={field}>
              <Button
                id={ELEMENTS_IDS.EDIT_FIELD_BUTTON}
                caption={"Edit location"}
                onClick={(): void => history.push(`${FIELDS}/edit/${field?.id}`)}
              />
            </FieldInfoBlock>

            <Spacer baselineHeight={3} />
          </PageHeader>

          <PageContent>
            <Spacer baselineHeight={3} />

            <AnimalsList
              excludedFilters={{ fieldId: true }}
              showAnimalActionButtons={false}
              showSelectColumn={false}
              fieldId={fieldId}
              fromPage="field"
            />
          </PageContent>
        </>
      )}
    </>
  );
};
